export default class FleetStatistics {

    constructor(devicesInactive = 0, devicesOnline = 0, devicesOffline = 0) {
        this.devicesInactive = devicesInactive
        this.devicesOnline = devicesOnline
        this.devicesOffline = devicesOffline
    }

}
